<template>
  <div
    role="dialog"
    class="tw-fixed tw-right-0 tw-top-0 tw-bottom-0 tw-z-30 tw-h-full tw-bg-white"
    :style="{ width: divWidth + 'px' }"
  >
    <div
      class="tw-absolute tw-h-full tw-border tw-border-primary-grey-50 hover:tw-cursor-col-resize hover:tw-border-4 hover:tw-border-primary-grey-100"
      @mousedown.stop.prevent="initResize"
    ></div>
    <div
      v-if="variant === 'dark'"
      class="tw-flex tw-items-center tw-justify-between tw-bg-primary-grey-800 tw-p-4 tw-text-white"
    >
      <slot name="title" />
      <button
        class="tw-p-1 tw-text-lg"
        :data-test-id="`${testId}-close`"
        @click="$emit('close')"
      >
        <cb-icon-close-2 color="currentColor" />
      </button>
    </div>
    <div v-else class="tw-flex tw-justify-between tw-p-4">
      <slot name="header" />
      <button :data-test-id="`${testId}-close`" @click="$emit('close')">
        <cb-icon-close-2 />
      </button>
    </div>
    <div :class="{ 'tw-h-full': variant === 'plain' }">
      <slot name="body" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";

type Props = {
  initialWidth?: number;
  minWidth?: number;
  maxWidth?: number;
  testId?: string;
  variant?: "dark" | "plain";
};

const props = withDefaults(defineProps<Props>(), {
  initialWidth: 800,
  minWidth: 450,
  maxWidth: 1200,
  testId: "slide-out",
  variant: "dark",
});

defineEmits<{ close: [] }>();

const divWidth = ref(props.initialWidth);
const startX = ref(0);
const startWidth = ref(0);

const initResize = (event: MouseEvent) => {
  startX.value = event.clientX;
  startWidth.value = divWidth.value;
  document.addEventListener("mousemove", onMouseMove);
  document.addEventListener("mouseup", onMouseUp);
};
const onMouseMove = (event: MouseEvent) => {
  const newWidth = startWidth.value - event.clientX + startX.value;
  if (newWidth > props.minWidth && newWidth < props.maxWidth) {
    divWidth.value = newWidth;
  }
};

const onMouseUp = () => {
  document.removeEventListener("mousemove", onMouseMove);
  document.removeEventListener("mouseup", onMouseUp);
};
</script>
